// 261010 dev-thumbs — chọn ảnh nhỏ cho dòng "Video N" (THUẦN, không antd, không đổi input).
// Mỗi bước chỉ hiện ảnh CỦA bước đó: Sơ đồ ⇒ ảnh sơ đồ các giai đoạn · Storyboard ⇒ ảnh storyboard. Không trùng url (nhiều giai đoạn có thể dùng chung một sơ đồ).
import type { PositionMapsResponse, Storyboard } from '../../types/film';
import type { WorkflowStepKey } from '../../types/filmWorkflow';
import { mapsOfEvent } from './workflowDetailUtils';

export const THUMB_MAX = 3;

const httpUrl = (u: unknown): string | null => (typeof u === 'string' && /^https?:\/\//i.test(u.trim()) ? u.trim() : null);

/** Chỉ http(s), khử trùng (giữ thứ tự lần đầu), cắt `max`. Luôn trả mảng MỚI. */
export function uniqueHttpUrls(urls: ReadonlyArray<unknown>, max = THUMB_MAX): string[] {
  const out: string[] = [];
  for (const u of urls ?? []) {
    const h = httpUrl(u);
    if (h && !out.includes(h)) out.push(h);
    if (out.length >= max) break;
  }
  return out;
}

export interface ThumbCtx {
  eventId: string;
  phaseOrders: number[];
  maps?: PositionMapsResponse | null;
  /** `undefined`/`null` = chưa có storyboard. */
  storyboard?: Pick<Storyboard, 'sheetUrl' | 'sheetRawUrl'> | null;
}

export function thumbsOfStep(step: WorkflowStepKey, c: ThumbCtx): string[] {
  if (step === 'MAP') {
    if (!c.maps) return [];
    return uniqueHttpUrls(mapsOfEvent(c.maps, c.eventId, c.phaseOrders).map((r) => r.map?.imageUrl));
  }
  if (step === 'STORYBOARD') {
    const sb = c.storyboard;
    return sb ? uniqueHttpUrls([httpUrl(sb.sheetUrl) ?? sb.sheetRawUrl]) : [];
  }
  return [];
}

/** Khoá React duy nhất, ổn định: bước + vị trí + url (url có thể lặp ở nơi khác ⇒ KHÔNG dùng url trần làm key). */
export const thumbKeysOf = (step: WorkflowStepKey, urls: string[]): string[] => urls.map((u, i) => `${step}:${i}:${u}`);
